export default {
  // API Capability Docs (management plane — developer JWT)
  async getCapabilities(appId, params = {}) {
    const query = new URLSearchParams(params).toString();
    return this.request(`/third-party/${appId}/capabilities${query ? '?' + query : ''}`);
  },

  async getCapabilityVersions(appId) {
    return this.request(`/third-party/${appId}/capabilities/versions`);
  },

  async saveCapabilities(appId, data) {
    return this.request(`/third-party/${appId}/capabilities`, {
      method: 'POST',
      body: data,
    });
  },

  async deleteCapabilityVersion(appId, version) {
    return this.request(`/third-party/${appId}/capabilities/${version}`, {
      method: 'DELETE',
    });
  },
};
